import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { useLocaleStore } from '@/store/locale';
import { setHtmlDir } from './rtl';

export const SUPPORTED_LOCALES = ['en', 'ru', 'ar'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

void i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: [...SUPPORTED_LOCALES],
    ns: ['common'],
    defaultNS: 'common',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
      lookupQuerystring: 'lang',
      lookupCookie: 'syron_locale',
      lookupLocalStorage: 'syron.locale',
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    returnNull: false,
  });

i18n.on('languageChanged', (lng) => {
  const base = (lng?.split('-')[0] ?? 'en') as SupportedLocale;
  setHtmlDir(base);
  if (SUPPORTED_LOCALES.includes(base)) {
    useLocaleStore.getState().setLocale(base);
  }
});

export default i18n;
